function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useApolloClient } from "@apollo/client";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import * as Sentry from "@sentry/core";
import { useCallback, useEffect, useRef } from "react";
import { Kind } from "@oui/lib/src/types";
import { ChatInputButton } from "./ChatInputButton";
import { View } from "./View";
import { startArtifactRequest, useArtifactResult } from "../hooks/useArtifactResult";
var noopOnInput = function() {};
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-55}
 */ export var ARTIFACT_HANDLERS = {};
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-55}
 */ export function registerChatInputArtifactHandler(key, callback) {
    ARTIFACT_HANDLERS[key] = callback;
}
/**
 * A `ChatInput` implementation for interaction with artifacts outside of the
 * conversation screen.
 *
 * Integrates with `startArtifactRequest`/`useArtifactResult` to properly track
 * artifact state when navigation around screens.
 *
 * Artifact specific handling logic can be customized via
 * `registerChatInputArtifactHandler`.
 *
 * When returning to this component, the artifact result is passed back to the
 * chatbot with the completion status.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-55}
 */ export function ChatInputArtifact(_param) {
    var _param_onInput = _param.onInput, onInput = _param_onInput === void 0 ? noopOnInput : _param_onInput, props = _object_without_properties(_param, [
        "onInput"
    ]);
    var navigate = useNavigation().navigate;
    var apollo = useApolloClient();
    var artifactStartedRef = useRef(false);
    var onInputRef = useRef(onInput);
    onInputRef.current = onInput;
    useArtifactResult(function(result) {
        artifactStartedRef.current = false;
        onInput({
            kind: Kind.InputArtifact,
            props: result
        });
    });
    var onStartArtifact = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var started, ensureStartArtifactRequest;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    artifactStartedRef.current = true;
                    if (!ARTIFACT_HANDLERS[props.artifactName]) return [
                        3,
                        2
                    ];
                    started = false;
                    ensureStartArtifactRequest = function(name) {
                        started = true;
                        startArtifactRequest(name);
                    };
                    return [
                        4,
                        ARTIFACT_HANDLERS[props.artifactName]({
                            startArtifactRequest: ensureStartArtifactRequest,
                            apollo: apollo,
                            navigate: navigate,
                            params: props.params
                        })
                    ];
                case 1:
                    _state.sent();
                    if (!started) {
                        onInputRef.current({
                            kind: Kind.InputArtifact,
                            props: {
                                complete: false
                            }
                        });
                        Sentry.captureException('Failed to startArtifactRequest in custom artifact handler', {
                            extra: {
                                artifactName: props.artifactName
                            }
                        });
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    startArtifactRequest(props.artifactName);
                    // @ts-expect-error we don't have precise enough types for routeName/params so we just have to trust
                    // the artifact props
                    navigate(props.artifactName, _object_spread({}, props.params));
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        props.artifactName,
        navigate,
        props.params,
        apollo
    ]);
    useFocusEffect(useCallback(function() {
        if (artifactStartedRef.current) {
            onInputRef.current({
                kind: Kind.InputArtifact,
                props: {
                    complete: false
                }
            });
        }
    }, []));
    useEffect(function() {
        if (props.retry) {
            onStartArtifact().catch(Sentry.captureException);
        }
    }, [
        props.retry,
        onStartArtifact
    ]);
    return props.retry ? null : /*#__PURE__*/ _jsx(View, {
        children: /*#__PURE__*/ _jsx(ChatInputButton, {
            onInput: function(action) {
                if (action.kind === Kind.InputButton) {
                    void onStartArtifact();
                }
            },
            label: props.buttonText
        })
    });
}
